module.exports = __webpack_public_path__ + "assets/img/Logitech-Workspace-w960.87b8af63.jpg";